import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import Loaders from '@/components/common/Loaders/Loaders.vue';

import './styles/table-list-loader.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'TableListLoader',
  props: {
  numberOfElementsToDisplay: {
    type: Number,
    default: 20
  },
  listStructure: {
    type: Object as PropType<{ [key: string]: number | boolean }>,
    default: () => ({})
  }
},
  setup(__props) {

const { numberOfElementsToDisplay, listStructure } = __props;




return { __sfc: true,Loaders }
}

})